import { useCallback, useMemo, useState } from 'react';
import { Grid } from '@mui/material';

import { FormPart } from '@modules/shared/components/FormPart';
import { CheckboxListField } from '@shared/fields/CheckboxListField';
import { SaveButton } from '@shared/inputs/Buttons';
import { FlexEnd } from '@styles/StyledDiv';
import { PageContent } from '@styles/CommonStyles';
import { colorTheme } from '@styles/muiTheme';
import { INadaFormProps, IVehicleValuationOption } from '../interfaces';

const getLabel = (option: IVehicleValuationOption) => {
  const { description, tradeIn, retailAmount, accessoryCategory = '' } = option;
  const label = `${accessoryCategory} - ${description} - Retail Amount : $${retailAmount} - Trade In $${tradeIn}`;

  return label;
};

export const NadaForm = ({ options, value, handleFeatureSubmit }: INadaFormProps) => {
  const [disable, setDisable] = useState(false);

  const groups = useMemo(
    () => Array.from(new Set(options.map((item: IVehicleValuationOption) => item.accessoryCategory))),
    [options]
  );

  const formConfig = useMemo(
    () =>
      groups.map((group) => ({
        name: 'selectedOptions',
        label: group,
        component: CheckboxListField,
        options: options
          .filter((option) => option.accessoryCategory === group)
          .map((opt) => ({
            value: opt.id,
            label: getLabel(opt),
            disabled: opt.isDisabled,
            sx: {
              '&.Mui-checked': {
                color: opt.isMatchBumper ? colorTheme.palette.success.main : colorTheme.palette.primary.main,
              },
            },
          })),
      })),
    [groups, options, getLabel]
  );

  const handleSubmit = useCallback(async () => {
    setDisable(true);
    await handleFeatureSubmit(value);
    setDisable(false);
  }, [handleFeatureSubmit, value]);

  return (
    <>
      <PageContent>
        <Grid container>
          <FormPart config={formConfig} />
        </Grid>
      </PageContent>

      <FlexEnd>
        <SaveButton
          label="Okay"
          type="button"
          disabled={disable}
          onClick={handleSubmit}
        />
      </FlexEnd>
    </>
  );
};
